export function category(state){
    return state.category
}

export function department(state){
    return state.department
}

export function reward_user_points(state){
    return state.reward_user_points
}

export function reward_user_level_id(state){
    return state.reward_user_level_id
}

export function reward_user_level_points(state){
    return state.reward_user_level_points
}